// extracted by mini-css-extract-plugin
module.exports = {"title-container":"box-component_title-container__ccUHp","children-container":"box-component_children-container__1hztl"};